import { Button, Space } from 'antd'
import React, { useState } from 'react'
import { ReactMultiEmail } from "react-multi-email";
import 'react-multi-email/dist/style.css';
const CredentialForm = (props) => {
  let _invalidEmails =[]
  let emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
  const removeDuplicates = (list) => Array.from(new Set(list));
  return (
    <div className='card-data-spacing'>
    <div className='card-data-spacing'>
        <label>Enter Email Ids</label>
        <ReactMultiEmail
            className='w-75'
            placeholder="Input your Email Address"
            emails={props.credentialData.emails}
            onChange={(_emails) => {
              props.setCredentialData({...props.credentialData,emails:_emails});
            }}
            // validateEmail={email => {
            //   if (email === "undefined") {
            //     return false;
            //   }
    
            //   const isValid = emailRegex.test(email);
    
            //   if (!isValid && _invalidEmails.indexOf(email) === -1) {
            //     _invalidEmails.push(email);
            //     props.toast.warning({
            //       message:"Wrong request",
            //       description:"Enter a valid email address"
            //     })
            //   }
    
            //   return isValid;
            // }}
            getLabel={(
              email,
              index,
              removeEmail
            ) => {
              return (
                <div data-tag key={index}>
                  {email}
                  <span data-tag-handle onClick={() => removeEmail(index)}>
                    ×
                  </span>
                </div>
              );
            }}
          />
    </div>
    <Button type='primary' className='mt-4' style={{ width:120}} onClick={()=> props.requestCredentials()}>Submit</Button>
    </div>
  )
}

export default CredentialForm